// SchemaTreeSelector Constants

export const REACT_APP_CATALOG_SCHEMA_SERVICE_URL = 'https://catalogschema.products.cimpress.io';

export const SERVICE_ERROR = 'Error Fetching category details !';
